import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconTwitchBranded$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconTwitchBranded extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'caa7962e91988a3e5a21101f06e5a6fb12350ba8', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '174085b74fa6924376b235efeb98c48c5f5e54bb', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'bf4b80d767f71742997d9421b3f8a98d96977c72', d: "M6.857 3 4 5.857v10.286h3.429V19l2.857-2.857h2.285L17.714 11V3z", fill: "#9146FF" }), h("path", { key: 'c788e8c6317d601f7d6879f370e4691d8f0833ad', d: "m16.571 10.429-2.285 2.285H12l-2 2v-2H7.429V4.143h9.142z", fill: "#fff" }), h("path", { key: '1e4e0f50656ed2ad09a56c21ecbde5e5f9c4c0d4', d: "M13.714 6.143h1.143V9.57h-1.143zm-3.143 0h1.143V9.57h-1.143z", fill: "#9146FF" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-twitch-branded", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-twitch-branded"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-twitch-branded":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconTwitchBranded$1);
            }
            break;
    } });
}

const CosmosIconTwitchBranded = CosmosIconTwitchBranded$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconTwitchBranded, defineCustomElement };
